// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__qA0Wv","checkmark":"Checkbox_checkmark__G4LhW","input":"Checkbox_input__JJMHU"};